import { render } from "./loading-button.html?vue&type=template&id=34f5734a&scoped=true&ts=true"
import script from "./loading-button.vue?vue&type=script&lang=ts"
export * from "./loading-button.vue?vue&type=script&lang=ts"

import "./loading-button.scss?vue&type=style&index=0&id=34f5734a&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f5734a"]])

export default __exports__